import smoothscroll from 'smoothscroll-polyfill'

((w,d) => {
  
  w.addScript = (attrs) => {
    const [d,s] = [document,'script']
    const f=d.getElementsByTagName(s)[0],j=d.createElement(s)
    Object.keys(attrs).forEach(a=>j.setAttribute(a,attrs[a]))
    f.parentNode.insertBefore(j,f)
  }

  w.addStylesheet = (attrs) => {
    const [d,s] = [document,'link']
    const f=d.getElementsByTagName(s)[0],j=d.createElement(s)
    j.rel="stylesheet"
    Object.keys(attrs).forEach(a=>j.setAttribute(a,attrs[a]))
    f.parentNode.appendChild(j)
  }
  
  $(() => {
    // ポップアップウインドウ
    $(d).on('click','[data-plugin=openwindow]',function(e){
      e.preventDefault();
      var $this = $(this),
      data = $this.data(),
      size = 'width='+(data.width||600)+', height='+(data.height||500)+',';
      w.open(this.href,(data.title||'share this site'),size+"menubar=no, toolbar=no, scrollbars=yes");
    })

    // smoothscroll
    smoothscroll.polyfill()
    d.querySelectorAll('a[href^="#"]').forEach( v => v.addEventListener("click", 
      e => {
        const el = d.querySelector( e.target.getAttribute('href') )
        el.scrollIntoView({behavior: 'smooth', block: 'start'})
      })
    )
  })


})(window, document)